export default "__VITE_ASSET__BqNRG7ks__"